export class Catalog
{
	toggleFav(itemId, parent)
	{
		let el = $(parent)
		let action;

		if (el.hasClass("active")) action = "del"
		else action = "add"

		$.ajax({
			url: "/ajax.php?mid=24",
			type: "POST",
			data: {
				action: action,
				item_id: itemId,
			},
			dataType: "json",
			success: function(res) {
				if (res["success"]) {
					if (res["added"]) {
						el.addClass("active")
					} else {
						el.removeClass("active")
						el.blur()
					}

					$('.user-favorites__quantity').text(res['new_count']);

					if (res['new_count'])
					{
						$('.user-favorites').addClass('active');
					}
					else
					{
						$('.user-favorites').removeClass('active');
					}
				} else {
					alert(res["error"])
				}
			},
			error: function(err) {
				alert("Ошибка! Попробуйте повотрить запрос. Error: " + err)
			},
		})
	}

	applyEvents()
	{
		let _this = this;
		$('.goods-card__favorites').click(function(){_this.toggleFav();});
	}
}
